import styled from "styled-components"

export const Wrapper = styled.div`
  align-items: start;
  display: grid;
  row-gap: 32px;
`
